"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins, Ref } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import { AccountSessionMixins } from "@/service/account-session";
import { SessionStore } from "@/service/session";
import _ from "lodash";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import { Changeteam } from "@/service/Teamchange/changeteam";
import AuthPinLogin from "@/app_views/login/components/AuthPinLogin.vue";
import AccountDevice from "@/app_views/login/components/AccountDevice.vue";
import UiDialog from "@/components/dialog/UiDialog.vue";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import { UiFormAnnotations } from "@/components/form/annotations";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import { DeviceFormatter } from "@/service/DeviceInfo/deviceFormatter";
import i18n from "@/lang";
class changeTeamController extends UiFormController {
  constructor() {
    super(...arguments);
    this.password = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("headertoolbar.please_enter_the_password"),
      trigger: "blur"
    }
  ])
], changeTeamController.prototype, "password", 2);
let ChangeTeamItem = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.groupList = "";
    this.change_teamController = new changeTeamController();
    this.verify_types = "first";
    this.all_teams = SessionStore.get("all_team_id");
    this.now_team = SessionStore.get("now_team_id");
    this.isSubAccount = false;
    this.selectValue = false;
    this.change_team_verify = null;
    this.change_team_message = null;
    this.showChangeTeamVerify = _.debounce((data) => __async(this, null, function* () {
      if (this.change_team_verify) {
        return;
      }
      const h = this.$createElement;
      this.change_team_verify = this.$notify({
        title: this.$t("layout.change_team_prompt"),
        message: h("div", { style: "" }, [
          h("p", `${this.$t("layout.change_team_title", { name: data.name })}`),
          h(
            "button",
            {
              class: "update-btn",
              on: {
                click: this.changeTeamChoose
              }
            },
            `${this.$t("layout.change_team_btn")}`
          )
        ]),
        duration: 0
      });
    }), 3e3);
    this.changeTeamChoose = _.debounce(() => __async(this, null, function* () {
      yield this.changeTeamChooseBtn();
    }), 800);
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      this.isSubAccount = this.$session.mark.any("SYS:SWITCH_ORG", "SYS:ALL_MODULE") && this.$session.mark.is("SWITCH_ORG");
      this.change_team_verify = null;
      this.change_team_message = null;
      yield this.getTeamList();
    });
  }
  destroyed() {
    return __async(this, null, function* () {
    });
  }
  changeTeamChooseBtn() {
    return __async(this, null, function* () {
      try {
        this.change_team_verify.close();
        yield this.changeTeamButtonChoose(this.change_team_message.org_id);
      } catch (error) {
      }
    });
  }
  verifyPassword() {
    return __async(this, null, function* () {
      try {
        let response = yield API.post(
          `api://base.auth/api/v1/account/orgs/show/password/valid`,
          {
            password: this.change_teamController.password
          }
        );
        let _valid = response.data.status;
        if (_valid === "PASSWORD_VALID_FALI") {
          this.$message.error(
            this.$t("headertoolbar.password_input_error")
          );
          return;
        }
        if (_valid === "PASSWORD_VALID_SUCCESS") {
          this.verify_types = "second";
        }
      } catch (error) {
        console.log(error);
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getTeamList() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v1/team/teamlist`);
        let all_teams_id = SessionStore.get("all_team_id");
        let now_teams_id = SessionStore.get("now_team_id");
        let item = _.find(response.data.datas, { team_choose: true });
        let all_teams = response.data.datas;
        let now_teams = item.team_id;
        if (all_teams_id !== all_teams || now_teams_id !== now_teams) {
          SessionStore.set("all_team_id", all_teams);
          SessionStore.set("now_team_id", now_teams);
          this.all_teams = all_teams;
          this.now_team = now_teams;
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  changeTeamButtonChoose(data) {
    return __async(this, null, function* () {
      if (data === this.now_team) {
        return;
      }
      try {
        let item = _.find(this.all_teams, { team_id: data });
        let name = this.$t("headertoolbar.target_team");
        if (item !== void 0) {
          name = item.team_name;
        }
        yield this.getTeamList();
        let _browsers = yield API.get(`api://base.local/v2/browsers`);
        let _dynamicBrowsers = yield API.get(`api://base.local/v2/dynamic-browsers`);
        if (_browsers.data.data.length > 0 || _dynamicBrowsers.data.data.length > 0) {
          yield UiConfirm.warnconfirm(
            this.$t("headertoolbar.has_opening_browser", {
              name
            }),
            this.$t("headertoolbar.hint"),
            {
              confirmButtonText: this.$t("headertoolbar.confirm"),
              cancelButtonText: this.$t("headertoolbar.cancel"),
              iconClass: "el-icon-warning"
            }
          );
          yield API.delete(`api://base.local/v2/browsers`);
          yield API.delete(`api://base.local/v2/dynamic-browsers`);
          yield API.delete(`api://base.local/processes`);
        }
        yield UiConfirm.confirm(
          `${this.$t("headertoolbar.whether_to_switch", { name })}`,
          this.$t("headertoolbar.switch_team"),
          {
            confirmButtonText: this.$t("headertoolbar.confirm"),
            cancelButtonText: this.$t("headertoolbar.cancel")
          }
        );
        let loading = this.$loading({
          lock: true,
          fullscreen: true,
          text: this.$t(
            "headertoolbar.switching_teams_please_wait_a_moment"
          ),
          customClass: "hard-loading",
          background: "rgba(0, 0, 0, 0.8)"
        });
        let _res = yield Changeteam.change(data, "old");
        if (_res.type === "pin") {
          loading.close();
          yield this._auth_pin.open(_res.result, "team");
          return;
        }
        if (_res.type === "device") {
          loading.close();
          yield this._account_device.open(
            _res.result,
            "team"
          );
          return;
        }
        if (_res.type === "error") {
          loading.close();
          yield UiConfirm.confirm(
            `${_res.result}`,
            this.$t("headertoolbar.hint"),
            {
              confirmButtonText: this.$t("headertoolbar.confirm"),
              showCancelButton: false
            }
          );
        }
        if (_res.type === "success") {
          let _session = yield API.get(`api://base.auth.pro/v1/account/session`);
          const session = _session.data;
          yield API.put(`api://base.local/storages/session/session`, {
            session
          });
          localStorage.removeItem("gift_show");
          new Promise((resolve, reject) => {
            setTimeout(() => {
              loading.close();
              resolve(true);
            }, 1500);
          });
          try {
            yield API.post(`api://base.local/websockets/messageservice`, {
              model: "pageEvent.changeTeam.success",
              value: {
                message: "changeteam.success"
              }
            });
          } catch (error) {
          }
          yield this.sendLog();
          yield API.post(`api://base.local/websockets/view`, {
            model: "pageEvent.changeTeam.success",
            value: {
              message: "changeteam.success"
            }
          });
          yield API.post(`api://base.local/websockets/main`, {
            model: "change.team.success",
            value: {
              message: "changeteam.success"
            }
          });
          location.reload();
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  changeTeam(data) {
    return __async(this, null, function* () {
      let item = _.find(this.all_teams, { team_id: data });
      let name = this.$t("headertoolbar.target_team");
      if (item !== void 0) {
        name = item.team_name;
      }
      yield this.getTeamList();
      let _browsers = yield API.get(`api://base.local/v2/browsers`);
      let _dynamicBrowsers = yield API.get(`api://base.local/v2/dynamic-browsers`);
      if (_browsers.data.data.length > 0 || _dynamicBrowsers.data.data.length > 0) {
        yield UiConfirm.warnconfirm(
          this.$t("headertoolbar.has_opening_browser", {
            name
          }),
          this.$t("headertoolbar.hint"),
          {
            confirmButtonText: this.$t("headertoolbar.confirm"),
            cancelButtonText: this.$t("headertoolbar.cancel"),
            iconClass: "el-icon-warning"
          }
        );
        yield API.delete(`api://base.local/v2/browsers`);
        yield API.delete(`api://base.local/v2/dynamic-browsers`);
        yield API.delete(`api://base.local/processes`);
      }
      yield UiConfirm.confirm(
        `${this.$t("headertoolbar.whether_to_switch", { name })}`,
        this.$t("headertoolbar.switch_team"),
        {
          confirmButtonText: this.$t("headertoolbar.confirm"),
          cancelButtonText: this.$t("headertoolbar.cancel")
        }
      );
      let loading = this.$loading({
        lock: true,
        fullscreen: true,
        text: this.$t(
          "headertoolbar.switching_teams_please_wait_a_moment"
        ),
        customClass: "hard-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
      console.log("=========================================================");
      let _res = yield Changeteam.change(data, "old");
      if (_res.type === "pin") {
        loading.close();
        yield this._auth_pin.open(_res.result, "team");
        return;
      }
      if (_res.type === "device") {
        loading.close();
        yield this._account_device.open(
          _res.result,
          "team"
        );
        return;
      }
      if (_res.type === "error") {
        loading.close();
        yield UiConfirm.confirm(
          `${_res.result}`,
          this.$t("headertoolbar.hint"),
          {
            confirmButtonText: this.$t("headertoolbar.confirm"),
            showCancelButton: false
          }
        );
      }
      if (_res.type === "success") {
        let _session = yield API.get(`api://base.auth.pro/v1/account/session`);
        const session = _session.data;
        yield API.put(`api://base.local/storages/session/session`, {
          session
        });
        localStorage.removeItem("gift_show");
        new Promise((resolve, reject) => {
          setTimeout(() => {
            loading.close();
            resolve(true);
          }, 1500);
        });
        try {
          yield API.post(`api://base.local/websockets/messageservice`, {
            model: "pageEvent.changeTeam.success",
            value: {
              message: "changeteam.success"
            }
          });
        } catch (error) {
        }
        yield this.sendLog();
        yield API.post(`api://base.local/websockets/view`, {
          model: "pageEvent.changeTeam.success",
          value: {
            message: "changeteam.success"
          }
        });
        yield API.post(`api://base.local/websockets/main`, {
          model: "change.team.success",
          value: {
            message: "changeteam.success"
          }
        });
        location.reload();
      }
    });
  }
  changeTeamForTest(data) {
    return __async(this, null, function* () {
      if (data === this.now_team) {
        this.$message.error(
          this.$t("headertoolbar.at_now_test_team_tips")
        );
        return;
      }
      let item = _.find(this.all_teams, { team_id: data });
      let name = this.$t("headertoolbar.target_team");
      if (item !== void 0) {
        name = item.team_name;
      }
      yield this.getTeamList();
      let _browsers = yield API.get(`api://base.local/v2/browsers`);
      let _dynamicBrowsers = yield API.get(`api://base.local/v2/dynamic-browsers`);
      if (_browsers.data.data.length > 0 || _dynamicBrowsers.data.data.length > 0) {
        yield UiConfirm.warnconfirm(
          this.$t("headertoolbar.has_opening_browser", {
            name
          }),
          this.$t("headertoolbar.hint"),
          {
            confirmButtonText: this.$t("headertoolbar.confirm"),
            cancelButtonText: this.$t("headertoolbar.cancel"),
            iconClass: "el-icon-warning"
          }
        );
        yield API.delete(`api://base.local/v2/browsers`);
        yield API.delete(`api://base.local/v2/dynamic-browsers`);
        yield API.delete(`api://base.local/processes`);
      }
      let loading = this.$loading({
        lock: true,
        fullscreen: true,
        text: this.$t(
          "headertoolbar.switching_teams_please_wait_a_moment"
        ),
        customClass: "hard-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
      console.log("=========================================================");
      let _res = yield Changeteam.change(data, "old");
      console.log(_res);
      if (_res.type === "pin") {
        loading.close();
        yield this._auth_pin.open(_res.result, "team");
        return;
      }
      if (_res.type === "device") {
        loading.close();
        yield this._account_device.open(
          _res.result,
          "team"
        );
        return;
      }
      if (_res.type === "error") {
        loading.close();
        yield UiConfirm.confirm(
          `${_res.result}`,
          this.$t("headertoolbar.hint"),
          {
            confirmButtonText: this.$t("headertoolbar.confirm"),
            showCancelButton: false
          }
        );
      }
      if (_res.type === "success") {
        try {
          let _session = yield API.get(`api://base.auth.pro/v1/account/session`);
          const session = _session.data;
          yield API.put(`api://base.local/storages/session/session`, {
            session
          });
          localStorage.removeItem("gift_show");
          new Promise((resolve, reject) => {
            setTimeout(() => {
              loading.close();
              resolve(true);
            }, 1500);
          });
          yield this.sendLog();
          yield API.post(`api://base.local/websockets/messageservice`, {
            model: "pageEvent.changeTeam.success",
            value: {
              message: "changeteam.success"
            }
          });
          yield API.post(`api://base.local/websockets/view`, {
            model: "pageEvent.changeTeam.success",
            value: {
              message: "changeteam.success"
            }
          });
          yield API.post(`api://base.local/websockets/main`, {
            model: "change.team.success",
            value: {
              message: "changeteam.success"
            }
          });
          this.$router.push("/");
        } catch (error) {
          this.$router.push("/");
          console.log(error);
          if (error.hasOwnProperty("response")) {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      }
    });
  }
  closeVerify() {
    this.verify_types = "first";
    this.selectValue = false;
    this.change_teamController.password = "";
    this._change_team_dialog.hide();
  }
  showTeamList(value) {
    return __async(this, null, function* () {
      let e = {
        target: {
          dataset: {
            matomo: this.$store.state.matomo[0].id
          }
        }
      };
      this.$store.dispatch("matomo", { that: this, e });
      try {
        if (value === true) {
          let response = yield API.get(
            `api://base.auth/api/v1/orgs/show/password/valid`
          );
          let flag = response.data.password_valid;
          if (flag) {
            this.selectValue = true;
            this._change_team_dialog.show();
          }
          if (!flag) {
            this.selectValue = false;
          }
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  closeTeamVerify() {
    return __async(this, null, function* () {
      this.selectValue = false;
    });
  }
  sendLog() {
    return __async(this, null, function* () {
      try {
        let device = yield DeviceFormatter.getInfo();
        let version = yield API.get(`api://base.local/update/version`);
        let _version = version.data.version;
        let _session = yield API.get(
          `api://base.local/storages/session/session`
        );
        yield API.post(`api://base.auth/api/v3/client/logs`, {
          logs: [
            {
              name: "client.login",
              message: "login.success",
              datas: {
                time: {
                  time: new Date().getTime(),
                  date: new Date()
                },
                session: _session.data.value.session,
                version: _version,
                patch: _version,
                computer: {
                  graphics: device.device_info.detail.graphics,
                  os_arch: device.device_info.os_arch,
                  cpu: device.device_info.detail.cpu,
                  os: device.device_info.detail.osInfo,
                  memory: device.device_info.detail.mem,
                  network: device.device_info.detail.networkInterfaces,
                  time: {
                    date: new Date()
                  }
                }
              }
            }
          ]
        });
      } catch (error) {
        console.dir(error);
      }
    });
  }
};
__decorateClass([
  Ref("auth-pin")
], ChangeTeamItem.prototype, "_auth_pin", 2);
__decorateClass([
  Ref("account-device")
], ChangeTeamItem.prototype, "_account_device", 2);
__decorateClass([
  Ref("change-team-dialog")
], ChangeTeamItem.prototype, "_change_team_dialog", 2);
ChangeTeamItem = __decorateClass([
  Component({
    components: {
      UiForm,
      UiDialog,
      UiSubmit,
      AuthPinLogin,
      AccountDevice,
      PasswordInput
    }
  })
], ChangeTeamItem);
export {
  ChangeTeamItem as default
};
